<script lang="ts" setup>
  import { LanguageSwitcher } from '@bt/design-system'
  import { availableLocales, setPathByLocale } from '@/composables/languageSwitcher'
  import { useNavigationDataLayer } from '@/composables/data-layers/useNavigationDataLayer'
  import { useDataLayerHelpers } from '@/composables/data-layers/useDataLayerHelpers'

  const emit = defineEmits(['refreshAllData'])

  const navigationDataLayer = useNavigationDataLayer()
  const dataLayerHelpers = useDataLayerHelpers()

  const avLocales = computed(() => availableLocales())

  const pushDataLayer = (value: string) => {
    navigationDataLayer.pushNavigationDataLayer({
      event_category: 'language_change',
      page_type: dataLayerHelpers.getPageType(),
      event_action: value
    })
  }

  const onLangChange = (value: string) => {
    pushDataLayer(value)
    setPathByLocale(value)
    emit('refreshAllData', value)
  }
</script>

<template>
  <LanguageSwitcher
    :languages="avLocales"
    @change="onLangChange"
  />
</template>
